//For External Links
var externalLinks = document.getElementsByTagName("a");
for (var i = 0; i < externalLinks.length; i++) {
  var link = externalLinks[i];

  if (link.hostname != window.location.hostname) {
        link.setAttribute('target', '_blank');
       
      }
    
}


document.addEventListener('DOMContentLoaded', () => {
  const pageHeaders = document.querySelector('.PageHeaders');
  const sectionHeader = document.querySelector('header') || document.getElementById('header-component');

  if (!pageHeaders) return;

  const handleScroll = (event) => {
    // Get current scroll position regardless of which element is scrolling
    const scrollTarget = event.target === document ? document.documentElement : event.target;
    const scrollTop = scrollTarget.scrollTop || window.scrollY;
    const headerHeight = sectionHeader ? sectionHeader.offsetHeight : 0;

    if (scrollTop > pageHeaders.offsetTop) {
      pageHeaders.classList.add('sticky');
      pageHeaders.style.top = `${headerHeight}px`;
    } else {
      pageHeaders.classList.remove('sticky');
    }
  };
  document.addEventListener('scroll', handleScroll, true);
});



// Active tab
const tabLinks = document.querySelectorAll(".tabs li a");

tabLinks.forEach(link => {
    link.addEventListener("click", function() {
    tabLinks.forEach(item => item.classList.remove("active"));
        this.classList.add("active");
    });
});


const shopLookButtons = document.querySelectorAll(".collection-name-link");
const targetElement = document.querySelector(".section-resource-list");

if (targetElement) {
    shopLookButtons.forEach(button => {
        button.addEventListener("click", function() {
            targetElement.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });
    });
}